import m from "../../geodata/es2015/ukCountiesLow";
window.am4geodata_ukCountiesLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/ukCountiesLow.js
// module id = null
// module chunks = 